import React, { useState } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { Tooltip } from 'reactstrap'
import { Icon } from '../../atoms'

export default function SocialShare({ className, icons, onShare, showIconTitle }) {
  const [[hoveredIcon, hoveredIconRef], setHoveredIcon] = useState([])

  const disabledIcons = {
    whatsapp:
      window?.navigator?.userAgent?.match(/windows.*firefox/i) &&
      'Mit dem von Ihnen verwendeten Internetbrowser ist das Teilen einer Empfehlung über WhatsApp momentan nicht möglich. Bitte verwenden Sie einen anderen Internetbrowser.'
  }

  const handleIconClick = icon => {
    onShare && onShare(icon)
  }

  return (
    <>
      <div className={clsx('socialshare', className)} data-testid="socialshare">
        {icons.map(icon => {
          const disabled = !!disabledIcons[icon]
          const iconClass = icon === 'at' ? 'email' : icon

          return (
            <React.Fragment key={icon}>
              <Icon
                name={icon}
                title={!disabled ? iconClass : ''}
                disabled={disabled}
                className={clsx(iconClass, 'icon--xlarge')}
                onClick={() => {
                  handleIconClick(icon)
                }}
                onMouseEnter={e => {
                  setHoveredIcon([icon, e.target])
                }}
                onMouseLeave={() => {
                  setHoveredIcon([])
                }}
                data-testid={`socialshare-icon-${icon}`}
              />
              {showIconTitle ? <p>{icon}</p> : null}
            </React.Fragment>
          )
        })}
      </div>
      {disabledIcons[hoveredIcon] && hoveredIconRef && (
        <Tooltip boundariesElement={hoveredIconRef} target={hoveredIconRef} placement="auto" isOpen>
          {disabledIcons[hoveredIcon]}
        </Tooltip>
      )}
    </>
  )
}

SocialShare.propTypes = {
  className: PropTypes.string,
  icons: PropTypes.arrayOf(PropTypes.string),
  onShare: PropTypes.func,
  showIconTitle: PropTypes.bool
}

SocialShare.defaultProps = {
  icons: ['at', 'facebook', 'share', 'twitter', 'whatsapp']
}
